/**
 * sticky-buy.js — <sticky-buy>
 *
 * A shortcut back to the purchase form, never a second one. It submits the
 * real form, so there is exactly one place where a variant and quantity can be
 * chosen and exactly one thing that can be added to the cart.
 *
 * It appears only once the real controls have left the viewport, and it stays
 * in step with the selected variant.
 */

class StickyBuy extends HTMLElement {
  connectedCallback() {
    this.form = document.getElementById(this.dataset.form);
    this.button = this.querySelector('[data-sticky-add]');
    this.price = this.querySelector('[data-sticky-price]');
    if (!this.form) return;

    this.anchor = this.form.closest('[data-variant-region-buy]') || this.form;
    this.hidden = false;

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(
        ([entry]) => this.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0),
        { threshold: 0 }
      );
      this.observer.observe(this.anchor);
    }

    this.button?.addEventListener('click', () => {
      this.form.requestSubmit ? this.form.requestSubmit() : this.form.submit();
    });

    document.addEventListener('theme:variant:change', () => this.sync());
  }

  /** Mirrors whatever the purchase panel now says, rather than deriving it. */
  sync() {
    const livePrice = this.anchor
      ?.closest('.product-purchase__inner')
      ?.querySelector('[data-variant-region-price] .price .type-price-l');
    if (livePrice && this.price) this.price.textContent = livePrice.textContent.trim();

    const liveButton = this.form.querySelector('[data-add-to-cart]');
    if (liveButton && this.button) {
      this.button.disabled = liveButton.disabled;
      const label = this.button.querySelector('.button__label');
      const liveLabel = liveButton.querySelector('.button__label');
      if (label && liveLabel) label.textContent = liveLabel.textContent.trim();
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('sticky-buy')) {
  customElements.define('sticky-buy', StickyBuy);
}

export default StickyBuy;
